{#if expanded}
  <span class="tag is-primary">
    highlighted
  </span>
  {getHighlightReason(highlight)}
{:else}
<span class="tag is-primary tooltip" data-tooltip="{getHighlightReason(highlight)}">
  highlighted
</span>
{/if}


<script lang="ts">
export let expanded:boolean = false, highlight:string;


function getHighlightReason(highlight: string) {
    if(highlight === 'remote') {
      return 'This charity is in a remote location and does not receive many offers' 
    }
    else if (highlight === 'unsuccessful') {
      return 'This charity has been unsuccessful in previous requests for offers'
    }
    else {
      return '';
    }
  }
</script>